import React, {useState} from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMarker } from '@fortawesome/free-solid-svg-icons'
import { navigate } from "gatsby";

import people from "../assets/img/people.png";
import chatbox from "../assets/img/chatbox.png";
import { getUser, getUserMData } from "../helpers/auth";
import JobTitleModal from "./job-title-modal";

const RightSidebar = () => {
    const user = getUser();
    const userMetaData = getUserMData();
    const [isJobTitleModalOpen, setIsJobTitleModalOpen] = useState(false);

    const handleChangePlan = () => {
        navigate('/#section_change_plan');
    }

    return (
        <div className="col-md-3 right_sidebar">
            <JobTitleModal
                open={isJobTitleModalOpen}
                userMetaData={userMetaData}
                onClose={() => setIsJobTitleModalOpen(false)}
            />
            <div className="premium-colm">
                <div className="card">
                    <img src={people} className="card-img-top text-center" alt="people" />
                    <div className="card-body text-center">
                        <h5 className="card-title">{user.displayName ? user.displayName : 'Not set'}</h5>
                        <p className="card-text">Account : {user.uid}</p>
                        <div className="user_plan">Premium</div>
                        <div className="change_plan" onClick={() => handleChangePlan()}>Change plan</div>
                    </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item jb_tital">
                            Job title
                            <div>
                                <span>{userMetaData.jobTitle}</span>
                                <FontAwesomeIcon className="fa_icon p_edit" icon={faMarker} onClick={() => setIsJobTitleModalOpen(true)} />
                            </div>
                        </li>
                        <li className="list-group-item jb_tital">Country/region<span>{userMetaData.country}</span></li>
                    </ul>
                </div>
                <div className="how_meet_work">
                    <ul className="list-unstyled">
                        <li className="m_psw"><a href="#">How MeetNow works</a></li>
                        <li className="m_psw"><a href="#">Privacy and security</a></li>
                        <li className="m_psw"><a href="#">Support</a></li>
                    </ul>
                </div>
                <div className="chat">
                    <a href="#"><img src={chatbox} /></a>
                </div>
            </div>
        </div>
    ) 
}

export default RightSidebar;